import { render, staticRenderFns } from "./SpaceMiniMap.vue?vue&type=template&id=2420f42e&"
import script from "./SpaceMiniMap.vue?vue&type=script&lang=js&"
export * from "./SpaceMiniMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports